<template>
    <div>
        <div v-if="vg_selectedLocation?.id" class="rounded-[10px] bg-[#2B2C32] w-full">
            <div class="text-[24px] text-white px-4 py-4">
                <div class="flex justify-between">
                    <span class="font-semibold">Purchase Orders</span>

                    <div class="flex gap-3">
                        <button disabled class="flex flex-row items-center disabled:bg-field-black disabled:text-theme-modalbg text-white bg-theme-green rounded px-4 uppercase">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M19 9H15V3H9V9H5L12 16L19 9ZM11 11V5H13V11H14.17L12 13.17L9.83 11H11ZM19 20V18H5V20H19Z" class="fill-gray-700"/>
                            </svg>
                            <span class="text-sm">Export</span>
                        </button>
                        <button @click="openPurchaseOrderUpload" class="flex flex-row items-center disabled:bg-field-black disabled:text-theme-modalbg text-white bg-theme-green rounded px-4 uppercase">
                            <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <path d="M9,10V16H15V10H19L12,3L5,10H9M12,5.8L14.2,8H13V14H11V8H9.8L12,5.8M19,18H5V20H19V18Z" class="fill-white" />
                            </svg>
                            <span class="text-sm">Upload PO</span>
                        </button>
                        <button @click="createPurchaseOrder" class="flex flex-row items-center disabled:bg-field-black disabled:text-theme-modalbg text-white bg-theme-green rounded px-4 uppercase">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill="white"/>
                            </svg>
                            <span class="text-sm">Create New</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="w-full mt-6 px-2 py-4">
                <div class="rounded-[10px] bg-[#2B2C32] w-full py-4">
                    <new-table-lite
                        :is-static-mode="true"
                        :is-slot-mode="true"
                        :is-loading="table.loading"
                        :class="'w-full admin-table admin-table-custom'"
                        :columns="table.columns"
                        :rows="table.rows"
                        :total="table.totalRecords"
                        :sortable="table.sortable"
                        :page-size="table.pagesize"
                        :page="table.page"
                        @row-clicked="selectedRow"
                        :pageOptions='table.pageOptions'
                        :messages="{
                            pagingInfo: 'Total {2}',
                            pageSizeChangeLabel: 'Items per Page',
                            gotoPageLabel: 'Go to page',
                            noDataAvailable: 'No purchase order uploaded yet',
                        }"
                    >
                        <template v-slot:shipmentId="data">
                            <span>{{data?.value?.invoiceNumber ? data?.value?.invoiceNumber+' ('+data?.value?.shipmentId+')' : data?.value?.shipmentId}}</span>
                        </template>
                        <template v-slot:location="data">
                            <span>{{data?.value?.location?.name}}</span>
                        </template>
                        <template v-slot:createdAt="data">
                            <span>{{data?.value?.createdAt ? readAbleDate(data.value.createdAt): ''}}</span>
                        </template>
                        <template v-slot:status="data">
                            <div class="flex flex-row gap-2 items-center">
                                <div v-if="data.value.status=='inprogress'" class="font-bold text-white text-center flex justify-center items-center w-[100px] text-sm leading-[17.5px] tracking-[0.1px] h-[40px] rounded p-2 bg-[#B3261E]">In Progress</div>
                                <div v-else-if="data.value.status=='completed'" class="font-bold text-white text-center flex justify-center items-center w-[100px] text-sm leading-[17.5px] tracking-[0.1px] h-[40px] rounded p-2 bg-[#2BA66B]">Completed</div>
                            </div>
                        </template>
                    </new-table-lite>
                </div>
            </div>
        </div>
        <div v-else >
            <div class="flex lg:flex-row flex-col bg-[#2B2C32] rounded-xl"> 
                <div class="w-full">
                    <div class="bg-[#2B2C32] rounded-lg px-8 py-[16px]">
                        <p  class="text-center text-theme-red">Please select a location from the top left corner.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Env from '@/env';
import { defineComponent, ref} from 'vue'
import NewTableLite from '@/components/table/tableLite.vue'
import ProductApis from '@/controllers/BusinessProductApis'
import { mapGetters, mapMutations } from "vuex";
import moment from 'moment-timezone'
import { useSnackbar } from "vue3-snackbar"

export default defineComponent({
    components: {
        NewTableLite
    },
    setup() {
        const snackbar = useSnackbar();
        const table = ref({
          loading: true,
          columns: [
            {label: 'Invoice # (Shipment ID)', field: 'shipmentId', sortable:false, isKey:true },
            {label: 'Location', field:'location', sortable: false},
            {label: 'Status', field:'status', sortable:false},
            {label: 'Date', field:'createdAt', sortable:false},
            {label: 'Items', field:'numberOfItems', sortable:false},
            // {label: 'Employee', field:'employee', sortable:false},
          ],
          rows: [],
          totalRecords: 0,
          page: 1,
          sortable: {
            order: "",
            sort: "",
          },
           pagesize: Env.defaultPageSize,
           pageOptions: Env.pageList,
           count: 0
        })

        return {snackbar, table}
    },
    mounted(){
        this.fetchList()
        this.emitter.on("reloadPurchaseOrderList", this.reloadPurchaseOrderList);
    },
    beforeDestroy() {
        this.emitter.off("reloadPurchaseOrderList", this.reloadPurchaseOrderList);
    },
    computed: {
        ...mapGetters({
            vg_userToken: 'auth/userToken',
            vg_selectedLocation: 'location/selected',
        }),
    },
    watch: {
        'vg_selectedLocation.id'(){
            if(this.vg_userToken){
                this.fetchList()
            }else{
                this.$router.push('/login?sessionExpired=1')
            }
            
        }
    },
    methods: {
        openPurchaseOrderUpload(){
            this.toggleAddDropDown = false
            this.$emit('togglePurchaseOrderUploadPop', true)
        },
        async createPurchaseOrder(){
            this.vm_spinner(true)
            let data = {
                "shipmentId":null,
                "date":moment().format('YYYY-MM-DD'),
                "shippingCost":null,
                "tax":null,
                "total":null,
                "fullfillmentTime":null,
                "locationId":this.vg_selectedLocation.id
            }
            let res = await ProductApis.createPurchaseOrder(data)
            this.snackbar.add({
                type: 'info',
                text: res.status == 201 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
                duration: 3000,
            })
            this.vm_spinner(false)
            if(res.status===201){
                this.$router.push(`/purchase-orders/${res.data.payload.id}`)
            }
            
        },
        readAbleDate(str) {
            if(!str) return ''
            let defaultTimeZone = this.vg_selectedLocation.timezone?this.vg_selectedLocation.timezone:'America/Toronto';
            return moment(str).tz(defaultTimeZone).format('YYYY-MM-DD')
        },
        async reloadProductList(editItem){
            this.fetchList()
        },
        async fetchList(){
            if(this.vg_selectedLocation.id){
                this.table.loading = true
                let res = await ProductApis.purchaseOrderListV2(this.vg_selectedLocation.id)
                if(res.status===200){
                    this.table.rows = res.data.payload?.reverse()
                    this.table.pagesize = Env.defaultPageSize
                    this.table.totalRecords = res.data.payload.length
                }else{
                    this.table.rows = []
                    this.table.pagesize = Env.defaultPageSize
                    this.table.totalRecords = 0
                }
                this.table.loading = false
            }
        },
        selectedRow(item){
            if(item.status==='completed'){
                this.$router.push(`/purchase-orders-view/${item.id}`)
            }else{
                this.$router.push(`/purchase-orders/${item.id}`)
            }
        },
        ...mapMutations({
            vm_spinner: 'spinner/mutateSpinner'
        })
    }
})
</script>